import React, {useContext} from "react";
import "./Skills.scss";
import {illustration, skillsSection} from "../../portfolio";
import {Fade} from "react-reveal";
import codingPerson from "../../assets/lottie/codingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import StyleContext from "../../contexts/StyleContext";

const SKILL_ICONS = [
  {label: "Python",             icon: "fab fa-python"},
  {label: "JavaScript",         icon: "fab fa-js"},
  {label: "Ruby",               icon: "fas fa-gem"},
  {label: "Node.js",            icon: "fab fa-node-js"},
  {label: "Linux",              icon: "fab fa-linux"},
  {label: "Docker",             icon: "fab fa-docker"},
  {label: "Git",                icon: "fab fa-git-alt"},
  {label: "AI / Security",      icon: "fas fa-shield-alt"},
  {label: "Network Protocols",  icon: "fas fa-network-wired"},
];

export default function Skills() {
  const {isDark} = useContext(StyleContext);
  if (!skillsSection.display) {
    return null;
  }
  return (
    <div className={isDark ? "dark-mode main" : "main"} id="skills">
      <div className="skills-main-div">
        <Fade left duration={1000}>
          <div className="skills-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={codingPerson} />
            ) : (
              <img
                alt="Man Working"
                src={require("../../assets/images/developerActivity.svg")}
              />
            )}
          </div>
        </Fade>

        <Fade right duration={1000}>
          <div className="skills-text-div">
            <h1 className={isDark ? "dark-mode skills-heading" : "skills-heading"}>
              {skillsSection.title}
            </h1>
            <p className={isDark ? "dark-mode subTitle skills-text-subtitle" : "subTitle skills-text-subtitle"}>
              {skillsSection.subTitle}
            </p>

            <div className="skills-bullets">
              {skillsSection.skills.map((skill, i) => (
                <div key={i} className={isDark ? "dark-mode skill-bullet-item" : "skill-bullet-item"}>
                  <span className="skill-bullet-icon">▸</span>
                  <span className="skill-bullet-text">{skill}</span>
                </div>
              ))}
            </div>

            <div className="skills-tech-grid">
              {SKILL_ICONS.map((s, i) => (
                <div key={i} className={isDark ? "dark-mode skills-tech-chip" : "skills-tech-chip"}>
                  <i className={s.icon}></i>
                  <span>{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
}
